import { render } from "./CInternetConnection.vue?vue&type=template&id=4bb13585&scoped=true"
import script from "./CInternetConnection.vue?vue&type=script&lang=js"
export * from "./CInternetConnection.vue?vue&type=script&lang=js"

import "./CInternetConnection.vue?vue&type=style&index=0&id=4bb13585&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb13585"]])

export default __exports__